import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Login } from '../common/models/login';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { map, ReplaySubject } from 'rxjs';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userData: any;
  baseUrl = environment.baseCloud7CmsApiUrl;

  private currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();

  constructor(private httpclient: HttpClient, private router: Router) {
  }
  public login(login: Login){
    var loginObj = { userName: login.userName, password: login.password};
 
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'});
    return this.httpclient.post<User>( this.baseUrl + "/api/Authorization/login"
      , JSON.stringify(loginObj), {headers}).pipe(map(res => {
        const user = res;
        this.setCurrentUser(user);
        return user;
      }));
  }
  public isLoggedIn(): boolean {
    const token = localStorage.getItem('token'); 
    
    if (token != null) {
      return true;
    } else {
      return false;
    }
  } 

  SignOut() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.router.navigateByUrl("/login");
    localStorage.removeItem('merchant');
  }

  setCurrentUser(user: User) { 

    if (this.isExpired(user.token)) {
      this.SignOut();
      return;
    }
    
    user.roles = [];

    const parsedToken = this.getDecodedToken(user.token);

    const roles = parsedToken.role;

    if (parsedToken?.isAllOperatorHaveOnePermission) {
      localStorage.setItem('merchant', parsedToken.merchant);
    }

     

    Array.isArray(roles) ? user.roles = roles :user.roles.push(roles);

    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem("token", user.token);
    this.currentUserSource.next(user);
  }

  isExpired(token : string){ 

    if (token != null) {
      
      const expireDate = this.getDecodedToken(token).exp;

      const isExpired = expireDate < Math.floor(Date.now() / 1000);


      return isExpired;
    } 

  return false;
  }

  getDecodedToken(token : string){
    return JSON.parse(atob(token.split('.')[1]));
  }

  getMerchantNameFromLocalStorage(){
    return localStorage.getItem('merchant');
  }
 
}
